module.exports = __webpack_public_path__ + "static/media/CX-Chains-Overview.f2dcb199.md";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXs/content/CX-Chains-Overview.md
// module id = 1263
// module chunks = 0